
export const ERROR_IDS = {
    INVALID_PLATFORM: 'invalid-platform',
    ALREADY_SUBMITTED: 'already-submitted',
    UNKNOWN_ERROR: 'unknown-error',
    INVALID_INVITATION_CODE: 'invalid-invitation-code',
}

const ERROR_DETAILS_MAP = {
    [ERROR_IDS.INVALID_PLATFORM]: 'Invalid Platform',
    [ERROR_IDS.ALREADY_SUBMITTED]: 'Survey Already Submitted',
    [ERROR_IDS.UNKNOWN_ERROR]: 'Unknown Error',
    [ERROR_IDS.INVALID_INVITATION_CODE]: 'Invalid or Already-Used Invitation Code',
};

function getErrorDetails(id) {
    return ERROR_DETAILS_MAP[id] ?? ERROR_DETAILS_MAP[ERROR_IDS.UNKNOWN_ERROR];
}

export function create(id) {
    return {error: id};
}

export function getDetails(error) {
    if(typeof error === 'string') {
        return getErrorDetails(error);
    } else {
        return getErrorDetails(error.error);
    }
}